export default __webpack_public_path__ + "static/media/boomerang_logo.6fdad8e3.svg";